import { useUsers } from "@/stores/users"
import { useProfiles } from "@/stores/profiles"
import { hasPermission } from "@/router/protected-routes"
import type { RouteRecordRaw } from "vue-router"

function getUserName() {
  const userStore = useUsers()
  const user = userStore.user
  return user.first_name
    ? user.first_name + " " + user.last_name + " (" + user.id + ")"
    : ""
}

function getProfileName() {
  const profileStore = useProfiles()
  return profileStore.profile.name || ""
}

const userRoutes: RouteRecordRaw[] = [
  {
    path: "team-members",
    name: "teamMembers",
    component: () => import("@/views/UserProfileTeamMembersView.vue"),
    meta: { breadcrumb: "userMenu.team_members" },
    children: [
      {
        path: "",
        name: "teamMembersList",
        component: () =>
          import("@/templates/user/UserProfileTeamMembersList.vue")
      },
      {
        path: "details/:userId/",
        name: "teamMemberDetails",
        component: () =>
          import("@/templates/user/UserProfileTeamMemberDetails.vue"),
        meta: { breadcrumb: getUserName }
      },
      {
        path: "register/:userId?/",
        name: "teamMembersRegister",
        component: () => import("@/templates/user/UserRegisterAndUpdate.vue"),
        meta: { breadcrumb: "userProfileTeamMembers.register" },
        beforeEnter: () => {
          return hasPermission("/api/v1/register", "post")
        }
      }
    ],
    beforeEnter: () => {
      return hasPermission("/api/v1/all_users", "get")
    }
  },
  {
    path: "profiles",
    name: "allProfiles",
    component: () => import("@/views/UserProfileTeamMembersView.vue"),
    meta: { breadcrumb: "userMenu.profiles" },
    children: [
      {
        path: "",
        name: "userProfiles",
        component: () => import("@/templates/user/UserProfiles.vue")
      },
      {
        path: "details/:profileId(\\d+)",
        name: "profileDetails",
        component: () => import("@/templates/user/UserProfileDetails.vue"),
        meta: { breadcrumb: getProfileName }
      },
      {
        path: "request/:profileId(\\d+)?",
        name: "profileRequest",
        component: () => import("@/templates/user/UserProfileRequest.vue"),
        meta: { breadcrumb: "userProfiles.request" },
        beforeEnter: () => {
          return hasPermission("/api/v1/profiles", "post")
        }
      }
    ],
    beforeEnter: () => {
      return hasPermission("/api/v1/groups", "get")
    }
  },
  // {
  //   path: "system-log",
  //   name: "userSystemLog",
  //   component: () => import("@/templates/user/UserSystemLog.vue"),
  //   meta: { breadcrumb: "userMenu.system_log" }
  // },
  {
    path: "my-account",
    name: "myAccount",
    component: () =>
      import("@/templates/user/UserProfileTeamMemberDetails.vue"),
    meta: { breadcrumb: getUserName }
  }
]

export default userRoutes
